import { Http } from '../http';
import axiosInstance from './axios-instance';
import { getFavoritesEndpoint } from '../../config/favorites';

export default {
  validateToken: (logData, token, useProdApis) => {
    const logToClickStream = true;
    const data = { token };
    const params = {};
    const url = `${getFavoritesEndpoint(useProdApis)}api/favorites/validate`;
    return new Http(axiosInstance.get())
      .post(logData, url, data, params, logToClickStream)
      .then(response => response.data);
  },

  getInitialData: (logData, favoriteToken, useProdApis) => {
    const logToClickStream = true;
    const params = {};
    const headers = { Authorization: `Bearer ${favoriteToken}` };
    const url = `${getFavoritesEndpoint(useProdApis)}api/favorites/user`;
    return new Http(axiosInstance.get())
      .get(logData, url, params, logToClickStream, headers)
      .then(response => response.data);
  },

  setComingSoon: (logData, notified, favoriteToken, useProdApis) => {
    const logToClickStream = true;
    const params = {};
    const data = { notified: notified };
    const headers = { Authorization: `Bearer ${favoriteToken}` };
    const url = `${getFavoritesEndpoint(useProdApis)}api/user/comingsoon`;
    return new Http(axiosInstance.get())
      .post(logData, url, data, params, logToClickStream, headers)
      .then(response => response.data);
  },

  setEndgame: (logData, notified, favoriteToken, useProdApis) => {
    const logToClickStream = true;
    const params = {};
    const data = { notified: notified };
    const headers = { Authorization: `Bearer ${favoriteToken}` };
    const url = `${getFavoritesEndpoint(useProdApis)}api/user/endgame`;
    return new Http(axiosInstance.get())
      .post(logData, url, data, params, logToClickStream, headers)
      .then(response => response.data);
  },

  followFavorite: (
    logData,
    favoriteToken,
    sportType,
    itemName,
    locale,
    market,
    offering,
    useProdApis
  ) => {
    const logToClickStream = true;
    const data = {
      market,
      offering,
      sportName: sportType,
      englishName: itemName,
      lang: locale
    };

    const params = {};
    const headers = { Authorization: `Bearer ${favoriteToken}` };
    const url = `${getFavoritesEndpoint(useProdApis)}api/favorites`;
    return new Http(axiosInstance.get())
      .post(logData, url, data, params, logToClickStream, headers)
      .then(response => response.data);
  },

  unfollowFavorite: (
    logData,
    favoriteToken,
    sportType,
    itemName,
    useProdApis
  ) => {
    const logToClickStream = true;
    const params = {};
    const headers = { Authorization: `Bearer ${favoriteToken}` };
    const url = `${getFavoritesEndpoint(
      useProdApis
    )}api/favorites/${encodeURIComponent(itemName)}/${sportType}/user`;
    return new Http(axiosInstance.get())
      .delete(logData, url, params, logToClickStream, headers)
      .then(response => response.data);
  }
};
